import { resolveLoginReturnTo } from "./loginPath";

export const isAtozasHomepageReferrer = (referrer = typeof document !== "undefined" ? document.referrer : "") => {
  const value = String(referrer || "").toLowerCase();
  return value.includes("atozasindia.in") || value.includes("testatozas.in");
};

export const isAtozasProductEntry = () => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  if (params.get("logged_out") === "1") return false;
  if (params.get("sso_error")) return false;
  try {
    if (sessionStorage.getItem("sso_logged_out") === "1") return false;
  } catch {
    // Ignore storage failures
  }
  if (params.get("homepage_key")) return true;
  return isAtozasHomepageReferrer();
};

export const ssoReturnToFromLocation = () => {
  if (typeof window === "undefined") return "/";
  if (window.location.pathname.startsWith("/login") || window.location.pathname.startsWith("/register")) {
    const params = new URLSearchParams(window.location.search);
    return resolveLoginReturnTo(params.get("redirect"));
  }
  const params = new URLSearchParams(window.location.search);
  params.delete("homepage_key");
  const query = params.toString();
  return `${window.location.pathname}${query ? `?${query}` : ""}` || "/";
};
